import React from "react";
import { GiLotusFlower } from "react-icons/gi";
import OmSymbol from "./OmSymbol";

/**
 * Subtle decorative floating Om / lotus / sparkle elements for ambiance.
 * Purely decorative — hidden from assistive tech. Place inside a `relative`
 * hero container so the elements are clipped to it.
 *
 * @param {string} variant - "om" (Om focused) | "mixed" (om + lotus + sparkles)
 */
export default function FloatingDecor({ variant = "mixed" }) {
  const Om = (props) => <OmSymbol {...props} />;
  const Lotus = (props) => <GiLotusFlower {...props} />;

  const items =
    variant === "om"
      ? [
          { icon: <Om size={48} />, className: "top-10 left-6 text-maroon-100/25 animate-float", delay: "0s" },
          { icon: <Om size={40} />, className: "bottom-12 right-10 text-maroon-100/20 animate-float-slow", delay: "0.6s" },
          { icon: "✦", className: "top-1/3 right-1/4 text-gold-300 text-2xl animate-twinkle", delay: "0.2s" },
          { icon: "✦", className: "bottom-1/4 left-1/4 text-gold-300 text-xl animate-twinkle", delay: "1s" },
        ]
      : [
          { icon: <Om size={48} />, className: "top-10 left-6 text-maroon-100/25 animate-float", delay: "0s" },
          { icon: <Lotus size={40} />, className: "top-24 right-8 text-saffron-300/30 animate-float-slow", delay: "0.4s" },
          { icon: <Lotus size={32} />, className: "bottom-16 left-12 text-saffron-300/25 animate-float", delay: "0.8s" },
          { icon: "✦", className: "top-1/3 right-1/4 text-gold-300 text-2xl animate-twinkle", delay: "0.2s" },
          { icon: "✦", className: "bottom-1/4 left-1/3 text-gold-300 text-xl animate-twinkle", delay: "1.1s" },
          { icon: "✧", className: "top-1/2 right-10 text-gold-200 text-lg animate-twinkle", delay: "0.6s" },
        ];

  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden select-none">
      {items.map((it, i) => (
        <span
          key={i}
          className={`absolute ${it.className}`}
          style={{ animationDelay: it.delay }}
        >
          {it.icon}
        </span>
      ))}
    </div>
  );
}
